/** Corporate suffixes ignored when deriving initials (e.g. "Acme Inc" → "A"). */
const CORPORATE_SUFFIXES = new Set([
  'inc',
  'ltd',
  'llc',
  'corp',
  'co',
  'gmbh',
  'sa',
  's.a.',
  'plc',
  'ag',
]);

const isSignificant = (word) =>
  word.length > 0 && !CORPORATE_SUFFIXES.has(word.replace(/[.,]/g, '').toLowerCase());

/**
 * Initials from the first letter of the first two significant words, uppercased,
 * ignoring corporate suffixes. Reproduces the prototype:
 *   "Spreadsheet"           → "S"
 *   "Internal Billing API"  → "IB"
 *
 * @param {string} name
 * @returns {string}
 */
export const initialsOf = (name) => {
  if (!name || typeof name !== 'string') return '';
  const words = name
    .trim()
    .split(/\s+/)
    .filter(isSignificant);
  if (words.length === 0) return '';
  return words
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join('');
};
